import axios from 'axios';

export default {
  // Admin
  findAdminPVCampaign: (data) => {
    return axios.put(`/api/pv/admin/campaigns`, data)
      .then(response => {
        return {
          campaigns: response.data.campaigns != null
            ? response.data.campaigns : [],
      }});
  },

  addAdminPVCampaign: (payload) => {
    return axios.post('/api/pv/admin/campaigns', payload)
      .then(response => ({
        campaign: response.data.campaign != null
          ? response.data.campaign : {},
      }));
  },

  saveAdminPVCampaign: (payload) => {
    return axios.put(`/api/pv/admin/campaigns/${payload.entityId}`, payload)
      .then(response => ({
        campaign: response.data.campaign != null
          ? response.data.campaign : {},
      }));
  },

  getAdminPVCampaign: (payload) => {
    return axios.get(`/api/pv/admin/campaigns/${payload.entityId}`, payload)
      .then(response => ({
        campaign: response.data.campaign != null
          ? response.data.campaign : {},
      }));
  },

  publiciseAdminPVCampaign: (payload) => {
    return axios.put(`/api/pv/admin/campaigns/${payload.entityId}/publicise`, payload)
      .then(response => ({
        campaign: response.data.campaign != null
          ? response.data.campaign : {},
      }));
  },

  cloneAdminPVCampaign: (payload) => {
    return axios.post(`/api/pv/admin/campaigns/${payload.entityId}/clone`, payload)
      .then(response => ({
        campaigns: response.data.campaigns != null
          ? response.data.campaigns : [],
      }));
  },

  deleteAdminPVCampaign: (payload) => {
    return axios.delete(`/api/pv/admin/campaigns/${payload.entityId}?deleteCode=${payload.deleteCode}`)
      .then(response => ({
        message: response.data.message != null
          ? response.data.message : '',
      }));
  },

  getAdminPVCampaignReceiptDetails: (payload) => {
    return axios.get(`/api/pv/admin/campaigns/${payload.entityId}/receipt-details`)
      .then(response => ({
        receiptsLength: response.data.receiptsLength != null
          ? response.data.receiptsLength : 0,
        confirmedReceiptLength: response.data.confirmedReceiptLength != null
          ? response.data.confirmedReceiptLength : 0,
        confirmedRegistrationLength: response.data.confirmedRegistrationLength != null
          ? response.data.confirmedRegistrationLength : 0,
        confirmedSurveyLength: response.data.confirmedSurveyLength != null
          ? response.data.confirmedSurveyLength : 0,
        confirmedAddressLength: response.data.confirmedAddressLength != null
          ? response.data.confirmedAddressLength : 0,
        confirmedReviewLength: response.data.confirmedReviewLength != null
          ? response.data.confirmedReviewLength : 0,
        confirmedCashbackLength: response.data.confirmedCashbackLength != null
          ? response.data.confirmedCashbackLength : 0,
        receiptsCtaDoneLength: response.data.receiptsCtaDoneLength != null
          ? response.data.receiptsCtaDoneLength : 0,
      }));
  },

  getAdminPVCampaignTransactionDetails: (payload) => {
    return axios.get(`/api/pv/admin/campaigns/${payload.entityId}/transaction-details`)
      .then(response => ({
        loginsLength: response.data.loginsLength != null
          ? response.data.loginsLength : 0,
        receiptScanLength: response.data.receiptScanLength != null
          ? response.data.receiptScanLength : 0,
        registrationScanLength: response.data.registrationScanLength != null
          ? response.data.registrationScanLength : 0,
        reviewModerationLength: response.data.reviewModerationLength != null
          ? response.data.reviewModerationLength : 0,
      }));
  },

  getAdminPVCampaignReviews: (payload) => {
    return axios.get(`/api/pv/admin/campaigns/${payload.entityId}/reviews/csv`)
      .then(response => ({
        reviews: response.data.reviews != null
          ? response.data.reviews : [],
      }));
  },

  // Company
  findCompanyCampaigns: (data) => {
    return axios.put('/api/pv/c/campaigns', data)
      .then(response => {
        return { campaigns: response.data.campaigns != null
          ? response.data.campaigns : []}
      });
  },

  getCompanyCampaign: (payload) => {
    return axios.get(`/api/pv/c/campaigns/${payload.campaignId}`)
      .then(response => ({
        campaign: response.data.campaign != null
          ? response.data.campaign : {},
      }));
  },

  addCompanyCampaign: (payload) => {
    return axios.post('/api/pv/c/campaigns', payload)
      .then(response => ({
        campaign: response.data.campaign != null
          ? response.data.campaign : {},
      }));
  },

  saveCompanyCampaign: (payload) => {
    return axios.put(`/api/pv/c/campaigns/${payload.entityId}`, payload)
      .then(response => ({
        campaign: response.data.campaign != null
          ? response.data.campaign : {},
      }));
  },

  deleteCompanyCampaign: (entityId) => {
    return axios.delete(`/api/pv/c/campaigns/${entityId}`)
      .then(response => ({
        message: response.data.message != null
          ? response.data.message : '',
      }));
  },
};
